import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { authenticate, resetPassword } from '../actions'
import { lang } from '../strings'
import { getLuhnSsn } from '../utils/ssn'
import { trackEvent, LOGIN, LOAD } from '../utils/analytics'

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = this.makeInitialState(props)
  }

  makeInitialState(props) {
    return {
      loginFailed: false,
      showResetPassword: false,
      resetPasswordStatus: null,
      orgNumber: '',
    }
  }

  render() {
    return (
      <div className='grid-margin-x grid-margin-y grid-x c-login white'>
        <div className='c-login__left'>
          <p className='sqsrte-large'>{lang.login.welcomeText}</p>
          <p>
            <strong>{lang.login.welcomeHeading}</strong>{' '}
            <a href='#'>
              <strong>{lang.login.welcomeHeadingLink}</strong>
            </a>
          </p>
          <p>{lang.login.welcomeText2}</p>
          {/* <p>
            <strong>{lang.login.welcomeHeading2}</strong>{' '}
          </p>
          <ul>
            <li>
              <strong>{lang.login.welcomeListItemHeading} </strong>
              {lang.login.welcomeListItem}
            </li>
            <li>
              <strong>{lang.login.welcomeListItemHeading2} </strong>
              {lang.login.welcomeListItem2}
            </li>
            <li>
              <strong>{lang.login.welcomeListItemHeading3} </strong>
              {lang.login.welcomeListItem3}
            </li>
          </ul> */}
          <h4 className='c-login__tagline'>
            <span className='sqsrte-text-color--accent'>
              <strong>
                <em>ETC Mobil – Surfa med gott samvete</em>
              </strong>
            </span>
          </h4>
        </div>
        <div className='c-login__right'>
          {this.renderLogin()}
          <div className='sqs-block-horizontalrule'>
            <hr />
          </div>
          {this.renderResetPassword()}
        </div>
      </div>
    )
  }

  componentDidMount() {
    trackEvent(LOGIN, LOAD)
  }

  renderLogin() {
    let { appState } = this.props
    let { orgNumber, loginFailed } = this.state
    let { networkProgress } = appState.toJS()

    let formClass = 'c-login__form form-block sqs-block-form'
    let buttonText = lang.login.button

    if (networkProgress) {
      formClass += ' mp-disabled'
      buttonText = lang.login.loading
    } else if (loginFailed) {
      formClass += ' mp-animated mp-shake'
    }

    return (
      <form onSubmit={this.login} className={formClass}>
        <div className='grid-y'>
          <strong>
            <em>{lang.login.title}</em>
          </strong>
          <p className='no-margin'>{lang.login.intro}</p>
          {loginFailed ? (
            <p className='mp-error-text'>{lang.login.loginError}</p>
          ) : null}
          <label htmlFor='orgNumber'>{lang.login.orgNumber}</label>
          <div className='form-item'>
            <input
              type='text'
              name='orgNumber'
              value={orgNumber}
              onChange={this.handleOrgNumber}
            />
            <label htmlFor='password'>{lang.login.password}</label>
            <input type='password' name='password' />
          </div>
          <div className='margin-top--smaller text-center flip-form'>
            <a href='#' className='link' onClick={this.showResetPassword}>
              {lang.login.resetPassword}
            </a>
          </div>
          <input
            type='submit'
            className='sqs-editable-button'
            value={buttonText}
          />
        </div>
      </form>
    )
  }

  renderResetPassword() {
    let { appState } = this.props
    let { orgNumber, resetPasswordStatus } = this.state
    let { networkProgress } = appState.toJS()

    let showStatus = resetPasswordStatus != null
    let showForm =
      resetPasswordStatus != Login.resetPasswordStatus.passwordReset

    let formClass = 'c-login__forgot-password-form form-block sqs-block-form'
    let buttonText = lang.resetPassword.button

    if (networkProgress) {
      formClass += ' mp-disabled'
      buttonText = lang.resetPassword.loading
    }

    return (
      <form className={formClass} onSubmit={this.handleResetPassword}>
        <div className='grid-y'>
          <strong>
            <em>{lang.resetPassword.title}</em>
          </strong>
          <p className='no-margin'>{lang.resetPassword.intro}</p>
          {showStatus && this.resetPasswordMessage(resetPasswordStatus)}
          <div className='form-item'>
            {showForm && (
              <label htmlFor='orgNumber'>{lang.resetPassword.orgNumber}</label>
            )}
            {showForm && (
              <input
                type='text'
                name='orgNumber'
                value={orgNumber}
                onChange={this.handleOrgNumber}
              />
            )}
          </div>
          {showForm && (
            <input
              type='submit'
              className='sqs-editable-button'
              value={buttonText}
            />
          )}
        </div>
      </form>
    )
  }

  resetPasswordMessage(resetPasswordStatus) {
    let messageClass = 'mp-success-text'
    let message = lang.resetPassword.successMessage

    if (resetPasswordStatus == Login.resetPasswordStatus.notFound) {
      messageClass = 'mp-error-text'
      message = lang.resetPassword.notFoundError
    }
    if (resetPasswordStatus == Login.resetPasswordStatus.notVerified) {
      messageClass = 'mp-error-text'
      message = lang.resetPassword.notVerifiedError
    }
    return <p className={messageClass}>{message}</p>
  }

  login = ev => {
    ev.preventDefault()
    let form = ev.target

    let data = {
      orgNumber: getLuhnSsn(form.orgNumber.value),
      password: form.password.value,
    }

    this.props.dispatch(authenticate(data, this.onLoginFailed))
  }

  onLoginFailed = () => {
    this.setState({ loginFailed: true })
  }

  handleResetPassword = ev => {
    ev.preventDefault()
    let form = ev.target
    let orgNumber = getLuhnSsn(form.orgNumber.value)

    this.props.dispatch(resetPassword(orgNumber, this.onPasswordReset))
  }

  onPasswordReset = data => {
    this.setState({ resetPasswordStatus: data.status })
  }

  showLogin = ev => {
    ev.preventDefault()
    this.setState({
      showResetPassword: false,
      loginFailed: false,
    })
  }

  showResetPassword = ev => {
    ev.preventDefault()
    this.setState({
      showResetPassword: true,
      resetPasswordStatus: null,
      loginFailed: false,
    })
  }

  handleOrgNumber = ev => {
    this.setState({ orgNumber: ev.target.value })
  }
}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
  appState: PropTypes.object.isRequired,
}

Login.resetPasswordStatus = {
  notFound: 0,
  notVerified: 1,
  passwordReset: 2,
}

function propProvider(reduxState, props) {
  const { appState } = reduxState

  return {
    appState,
  }
}

export default connect(propProvider)(Login)
